import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes with conflict resolution
 * Uses clsx for conditional classes and tailwind-merge for deduplication
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Conditional class utility for responsive design
 */
export function responsiveClass(
  base: string,
  sm?: string,
  md?: string,
  lg?: string,
  xl?: string
) {
  return cn(
    base,
    sm && `sm:${sm}`,
    md && `md:${md}`,
    lg && `lg:${lg}`,
    xl && `xl:${xl}`
  );
}

/**
 * Variant utility for component styling
 */
export function variantClass(
  base: string,
  variants: Record<string, string>,
  variant?: string
) {
  return cn(base, variant && variants[variant]);
}

/**
 * Size utility for component sizing
 */
export function sizeClass(
  sizes: Record<string, string>,
  size?: string,
  defaultSize = 'md'
) {
  return sizes[size || defaultSize] || sizes[defaultSize];
} 